<template>
  <div>
    <div class="student pointer my-1 p-1" v-for="(s, i) in studentList" :key="i"
      :class="{active: student === s}"  @click="onSelectStudent(s)">
      <mdb-icon  icon="grip-vertical" class="mx-2"/> {{s.name}}
    </div>
    <mdb-pagination sm class="mt-2 justify-content-center">
      <mdb-page-item v-for="(p, i) in totalPage" :key="i" :class="{active: page === (i+1)}"
        @click.native="page=p">
        {{p}}
      </mdb-page-item>
    </mdb-pagination>
  </div>
</template>
<script>
import { mdbPagination, mdbPageItem } from 'mdbvue';
export default {
  name: 'StudentList',
  components: { mdbPagination, mdbPageItem },
  props: ['training', 'init-student'],
  data: () => ({
    student: undefined,
    students: [],
    totalPage: 0,
    page: 1
  }),
  computed: {
    studentList () {
      const startIndex = this.page ? (this.page - 1) * 10 : 0
      return this.students.slice(startIndex, startIndex + 10)
    }
  },
  methods: {
    onSelectStudent (student) {
      this.student = student
      this.$emit('input', student);
    },
    async load () {
      if (!this.training) {
        this.students = []
        this.student = undefined
        return
      }
      this.students = await this.$member.studentList(this.training)
      this.totalPage = Math.ceil(this.students.length / 10)
      if (this.initStudent) {
        const ix = this.students.findIndex(s => s._id === this.initStudent)
        if (ix === -1) {
          this.page = 1
          this.$emit('input', undefined)
        } else {
          this.student = this.students[ix]
          this.page = Math.ceil(ix / 10)
          this.$emit('input', this.student)
        }
      }
    }
  },
  watch: {
    training: 'load'
  },
  async created () {
    this.load()
  }
}
</script>
<style scoped>
* {
  font-size: 14px;
}
.student {
  background-color: #eeeeee;
}
.student.active {
  background-color: #0d47a1;
  color: white;
}
</style>
